import React from 'react'
import PlafondInput from './PlafondInput'

interface PlafondRemiseGlobalProps {
    value: string | number | null | undefined
    onChange: (value: string | number) => void
}

const PlafondRemiseGlobal: React.FC<PlafondRemiseGlobalProps> = ({ value, onChange }) => {
    return (
        <div className="form-group row align-items-center mb-3">
            <label className="col-auto col-form-label">Seuil de remise global</label>
            <div className="col-auto">
                <PlafondInput value={value} onChange={onChange} />
            </div>
        </div>
    )
}

export default PlafondRemiseGlobal
